//修复toFixed的bug
Number.prototype.toFixed = function (fractionDigits) {
    var num = this; //console.log(num, fractionDigits);
    var f = Math.round(num * Math.pow(10, fractionDigits)) / Math.pow(10, fractionDigits);
    var s = f.toString();
    if (fractionDigits > 0) {
        var rs = s.indexOf('.');
        if (rs < 0) {
            rs = s.length;
            s += '.';
        }
        while (s.length <= rs + fractionDigits) {
            s += '0';
        }
    }
    return s;
};